import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FormGroupControl } from '@components/Base';

const GROUP_PROPS = { className: 'mb-3' };

const ContactInfoCardBody = () => {
  const { t } = useTranslation();

  return (
    <Card.Body>
      <Card.Title>{t('healthInsuranceClaimForm.contactInfoSection.title')}</Card.Title>
      <Row>
        <Col>
          <FormGroupControl required name="mobileNumber" label={t('user.mobileNumber')} groupProps={GROUP_PROPS} />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroupControl name="email" label={t('user.email')} groupProps={GROUP_PROPS} />
        </Col>
      </Row>
    </Card.Body>
  );
};

export { ContactInfoCardBody };
